export const DAS_REGEX = /^(https:\/\/das-web\.corelogic\.asia\/v1\/asset\/[a-zA-Z0-9]+).*$/;
export const modes = {
    EXACT: 'exact',
    LIMIT: 'limit'
};
export const presetDimensions = {
    LARGE: {
        width: 768,
        height: 512,
    },
    MEDIUM: {
        width: 470,
        height: 313,
    },
    THUMBNAIL: {
        width: 120,
        height: 80,
    },
    PROPERTY_FEATURED: {
        width: 354,
        height: 236,
    },
    PROPERTY_MEDIUM: {
        width: 228,
        height: 152,
    },
    PROPERTY_TARGET: {
        width: 375,
        height: 250,
    },
    SUMMARY_PRIMARY: {
        width: 498,
        height: 332,
    },
    SUMMARY_SECONDARY: {
        width: 150,
        height: 100,
    }
};

export const resizeTargetPhotoList = (value = []) => {
    return [...value, null, null]
      .slice(0, 2)
      .map(img => resizedDasWebUri({uri: img, mode: modes.EXACT, resizeDimensions: presetDimensions.LARGE}));
};

export const resizeSelectedImages = (value = []) => {
    return [...value, null, null, null, null]
      .slice(0, 4)
      .map((img) => resizedDasWebUri({
          uri: img,
          mode: modes.EXACT,
          resizeDimensions: presetDimensions.LARGE,
      }));
};

export default function resizedDasWebUri({uri, mode = modes.LIMIT, resizeDimensions: {width, height} = {}}) {
    if (uri && DAS_REGEX.test(uri) && width && height) {
        let baseUri = uri.replace(/resize;.*?($|\/)/, '');
        baseUri = baseUri.endsWith('/') ? baseUri : baseUri + '/';
        return baseUri + `resize;m=${mode};w=${width};h=${height};logo=false;date=false`;
    }
    return uri;
}